import { useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MainLayout, SubLayout } from '@/components/layout';
import { useSession } from '@/lib/session';
import { getStartParam } from '@/lib/telegram';
import CartPage from '@/pages/cart';
import CatalogPage from '@/pages/catalog';
import CategoriesPage, { CategoryDetailPage } from '@/pages/categories';
import CheckoutPage from '@/pages/checkout';
import FavoritesPage from '@/pages/favorites';
import HomePage from '@/pages/home';
import OfferPage from '@/pages/offer';
import ProductPage from '@/pages/product';
import ProfilePage from '@/pages/profile';
import SearchPage from '@/pages/search';
import { OrderDetailPage, OrdersPage } from '@/pages/orders';

export default function App() {
  const { ready } = useSession();
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Deep-link из бота: /start product_<id> открывает карточку сразу
  useEffect(() => {
    const param = getStartParam();
    if (!param) return;

    const [kind, value] = param.split('_');
    if (kind === 'product' && value) navigate(`/product/${value}`, { replace: true });
    if (kind === 'category' && value) navigate(`/catalog?categoryId=${value}`, { replace: true });
  }, [navigate]);

  if (!ready) {
    return (
      <div className="flex min-h-full items-center justify-center">
        <p className="text-sm text-muted">{t('common.loading')}</p>
      </div>
    );
  }

  return (
    <Routes>
      {/* Вкладки нижнего меню: шапка с поиском сверху, навигация снизу */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>

      {/* Вложенные экраны: возврат кнопкой «назад», без нижних вкладок */}
      <Route element={<SubLayout />}>
        <Route path="/categories/:id" element={<CategoryDetailPage />} />
        <Route path="/catalog" element={<CatalogPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/product/:id" element={<ProductPage />} />
        <Route path="/favorites" element={<FavoritesPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/orders/:id" element={<OrderDetailPage />} />
        <Route path="/offer" element={<OfferPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
